module.exports = __webpack_public_path__ + "img/c8ce8fd.svg";